namespace TabAurous.ECommerce {
    export interface OrderManagementCheckListRow {
        Id?: number;
        TransItemId?: number;
        TransId?: number;
        CheckListId?: number;
        CheckListName?: string;
        CheckListValue?: boolean;
    }

    export namespace OrderManagementCheckListRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'ECommerce.OrderManagementCheckList';
        export const deletePermission = 'EComm:ECommOrder:Delete';
        export const insertPermission = 'EComm:ECommOrder:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommOrder:Edit';

        export declare const enum Fields {
            Id = "Id",
            TransItemId = "TransItemId",
            TransId = "TransId",
            CheckListId = "CheckListId",
            CheckListName = "CheckListName",
            CheckListValue = "CheckListValue"
        }
    }
}
